module.exports = __webpack_public_path__ + "img/82.2cbae27a.jpg";